import { withMixpanelReplay } from "../withMixpanelReplay";
import { CollaborativeFormEditor } from "./CollaborativeFormEditor";

export const CollaborativeFormEditorWithReplay = withMixpanelReplay(
  CollaborativeFormEditor,
  {
    componentName: "CollaborativeFormEditor",
    scopeKey: "CollaborativeFormEditor",
  }
);